/**
 * Zod schemas + types for the native tool packages API (P2.5-B).
 *
 * Imported by both `apps/portal-api` and `apps/portal-frontend` for
 * end-to-end type safety (ADR-005). This file MUST NOT import Node-only
 * modules — it is bundled into the Workers runtime and the browser.
 */
import { z } from "zod";
/** The four built-in (native) tool package identifiers. */
export const NATIVE_TOOL_PACKAGE_NAMES = ["crm", "sms", "calendar", "content"];
/**
 * Metadata describing a single tool package for the UI — label, description,
 * and any external requirements (e.g. "Requires Twilio credentials").
 */
export const ToolPackageMetaSchema = z.object({
    name: z.string(),
    label: z.string(),
    description: z.string(),
    /** Human-readable requirement tokens, e.g. ["twilio"] or ["booking_link"]. */
    requirements: z.array(z.string()),
});
/** `GET /api/v1/agents/:id/tool-packages` response. */
export const AgentToolPackagesResponseSchema = z.object({
    /** Package names currently enabled for this agent. */
    enabled: z.array(z.string()),
    /** Full metadata for every available package (for the toggle UI). */
    available: z.array(ToolPackageMetaSchema),
});
/** `PUT /api/v1/agents/:id/tool-packages` request body. */
export const UpdateAgentToolPackagesRequestSchema = z.object({
    enabled: z.array(z.enum(NATIVE_TOOL_PACKAGE_NAMES)),
});
//# sourceMappingURL=agent-tools.js.map